import {FlightTypeEnum, PlaceFragment} from "./graphql/queries"
import {ModalWithProps} from "./modalTypes"
import {ID} from "./model/id"

export function isEmptyJourney(journey: BookingFormJourneyState): boolean {
  return !journey.origin && !journey.destination && journey.waypoints.length === 0;
}

export interface BookingFormJourneyState {
  origin: PlaceFragment | null
  destination: PlaceFragment | null
  waypoints: Array<PlaceFragment>
}

export interface BookingFormAirportState {
  airlineCode: string
  flightType: FlightTypeEnum
  flightNumber: string
}

export interface BookingFormPassengerState {
  id: ID | null
  name: string
  email: string | null
  mobile: string | null
  phone: string | null
}

export interface ModalState {
  modal: ModalWithProps | null
}



// WEBPACK FOOTER //
// ./src/state.ts